export function Logo({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg
        width="28"
        height="28"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Uniskai logo"
      >
        <defs>
          <linearGradient
            id="uniskaiGrad"
            x1="0"
            y1="0"
            x2="32"
            y2="32"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#8b5cf6" />
            <stop offset="1" stopColor="#06b6d4" />
          </linearGradient>
        </defs>
        <rect width="32" height="32" rx="8" fill="url(#uniskaiGrad)" />
        <path
          d="M16 7l1.8 5.5h5.7l-4.6 3.4 1.7 5.5-4.6-3.4-4.6 3.4 1.7-5.5-4.6-3.4h5.7L16 7z"
          fill="#08080b"
        />
      </svg>
      <span className="text-lg font-semibold tracking-tight text-foreground">
        Uniskai
      </span>
    </div>
  );
}
